module.exports = __webpack_public_path__ + "static/media/km.6d074963.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/km.svg
// module id = 164
// module chunks = 0